import { CheckboxProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";

export class DemoCheckboxExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("caption", {
            examples: [
                { value: "Option One" },
                { value: "Some other caption to demonstrate what changing it does" },
            ]
        });
        this.registerPropertyExamples("checkColor", {
            examples: [
                { value: "primary", description: "This Checkbox uses the current theme's primary color." },
                { value: "green", description: "This Checkbox is green." },
            ]
        });
        this.registerPropertyExamples("checked", {
            examples: [
                { value: true, description: "This Checkbox is checked." },
                { value: false, description: "This Checkbox is unchecked." },
            ]
        });
        this.registerPropertyExamples("focusable", {
            examples: [
                { value: true, description: "Note how you can tab into this Checkbox and that it maintains focus after toggling the value (via the spacebar)." },
                { value: false, description: "This Checkbox isn't allowed to gain focus." },
            ]
        });
        this.registerPropertyExamples("printable", {
            examples: [
                { value: true, props: {checked: true}, description: "This example shows how a printable Checkbox is displayed when checked." },
                { value: true, description: "This example shows how a printable Checkbox is displayed when unchecked." },
                { value: false, description: "This Checkbox is not printable." }
            ]
        });
        this.registerPropertyExamples("enabled", {
            examples: [
                { props: {enabled: true}, description: "This Checkbox is enabled." },
                { props: {enabled: false}, description: "This Checkbox is disabled." },
                { props: {enabled: false, checked: true}, description: "This Checkbox is disabled and checked." },
                { props: {enabled: false, checked: true, checkColor: "success"}, description: "This Checkbox is disabled and checked with a green check color." },
                { props: {enabled: false, checkColor: "success", color: "primary"}, description: "This Checkbox is disabled with a green check color and a blue caption." },
            ]
        });
    }

    protected override get propsForAllExamples(): Partial<CheckboxProps> {
        return {
            ...super.propsForAllExamples,
            caption: "Option One"
        };
    }
}
